import { Image } from '@educator/components/Image'
import type { InstructorItem } from './types'

interface InstructorCardProps {
  instructor: InstructorItem
}

export const InstructorCard = ({ instructor }: InstructorCardProps) => (
  <article
    aria-label={instructor.name}
    className='flex w-72 shrink-0 flex-col gap-6 md:w-80 md:gap-0'
  >
    <div className='relative h-96 w-72 overflow-hidden bg-edu-bg-tertiary md:w-80'>
      <Image
        src={instructor.imageUrl}
        alt={instructor.name}
        fill
        sizes='(max-width: 767px) 288px, 320px'
        className='object-cover'
      />
    </div>
    <div className='flex flex-col gap-3 md:py-4'>
      <h3 className='m-0 text-title-3 leading-title-3 font-normal text-edu-fg-primary'>
        {instructor.name}
      </h3>
      <p className='m-0 text-body-3 leading-body-2 text-edu-fg-primary md:text-body-2'>
        {instructor.description}
      </p>
    </div>
  </article>
)
